export default __webpack_public_path__ + "static/media/img-doc-warning.7de3d676.svg";